/** @format */

import React, { PureComponent } from 'react';
// import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';

import adescomStyle from 'assets/jss/adescom/adescomStyle';
import I18n from '../../../components/Translate/I18n';
import Button from '@material-ui/core/Button';
import IccidChooseNumberList from './IccidChooseNumberList';
import { ReactComponent as Cancel } from '../../../assets/themes/OPL/img/icons/Cancel.svg';

class IccidPoolChooseDialog extends PureComponent {
    onClicked = (v) => {
        this.props.callBackSetIccid(v);
    };

    render() {
        const { open, callBackClose, platformResellerId, businessId, indicatedRangeId, style, simCard } = this.props;
        return (
            <Dialog
                style={style}
                fullWidth={true}
                maxWidth="sm"
                open={open}
                keepMounted
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">
                    <GridContainer justifyContent={'space-between'}>
                        <h4>
                            <I18n trans="pools:pool.choose_iccid" />
                        </h4>
                        <Button onClick={callBackClose} color="primary">
                            <Cancel width={24} height={24} />
                        </Button>
                    </GridContainer>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" />
                    <GridContainer>
                        <GridItem xs={12}>
                            <IccidChooseNumberList
                                indicatedRangeId={indicatedRangeId}
                                clicked={this.onClicked}
                                platformResellerId={platformResellerId}
                                businessId={businessId}
                                simCard={simCard}
                            />
                        </GridItem>
                    </GridContainer>
                </DialogContent>
            </Dialog>
        );
    }
}

IccidPoolChooseDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    callBackSetIccid: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    platformResellerId: PropTypes.number.isRequired,
    businessId: PropTypes.string,
    indicatedRangeId: PropTypes.number,
    callBackClose: PropTypes.func.isRequired,
};

export default compose(withStyles(adescomStyle))(IccidPoolChooseDialog);
